export type RewriteState = 'EDITING' | 'SAVED_PREVIEW' | 'ANALYZED_PREVIEW';

interface PostFlags {
  savedSinceModeration?: boolean;
  analyzedSinceLastSave?: boolean;
}

export function deriveState(
  post: PostFlags,
  isEditingToggle: boolean,
): RewriteState {
  if (isEditingToggle) return 'EDITING';
  if (!post.savedSinceModeration) return 'EDITING';
  if (!post.analyzedSinceLastSave) return 'SAVED_PREVIEW';
  return 'ANALYZED_PREVIEW';
}
